import { defineMessages } from 'react-intl';

export default defineMessages({
  lockBatteryCritical: {
    defaultMessage: 'Critical',
    id: 'lock.battery.critical',
  },
  lockBatteryFull: {
    defaultMessage: 'Full',
    id: 'lock.battery.full',
  },
  lockBatteryHigh: {
    defaultMessage: 'High',
    id: 'lock.battery.high',
  },
  lockBatteryLow: {
    defaultMessage: 'Low',
    id: 'lock.battery.low',
  },
  lockBatteryMedium: {
    defaultMessage: 'Medium',
    id: 'lock.battery.medium',
  },
  lockBatteryUnknown: {
    defaultMessage: 'Unknown',
    id: 'lock.battery.unknown',
  },
});
